/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type RichiestaModuloDTOPermessiItem =
  (typeof RichiestaModuloDTOPermessiItem)[keyof typeof RichiestaModuloDTOPermessiItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RichiestaModuloDTOPermessiItem = {
  VISUALIZZAZIONE: 'VISUALIZZAZIONE',
  COMPILAZIONE: 'COMPILAZIONE',
  FIRMA: 'FIRMA',
} as const;
